import createModelStore from "../../utils/createModelStore";
import CarBodyType from "../../services/CarBodyType";

const carBodyTypes = createModelStore<CarBodyType.Model, "carBodyTypes">(
	"carBodyTypes",
);

export default carBodyTypes;
